export default "__VITE_PUBLIC_ASSET__acd35b35__"